/**
 * PARCHE CABSEN (2026-10-09): deteccion de pantalla tactil compartida por el visor.
 *
 * Se usa '(pointer: coarse)' (el puntero PRINCIPAL es un dedo) y no 'ontouchstart' ni maxTouchPoints, que
 * tambien dan positivo en portatiles con pantalla tactil manejados con raton. Asi un telefono o una tableta
 * cuentan como tactiles y un escritorio con raton no, aunque su pantalla admita toques.
 *
 * Usos: un solo contexto WebGL para cornerstone (extensions/cornerstone/src/init.tsx), abrir una serie con un
 * solo toque en la miniatura (components/Thumbnail) y el texto del aviso de perdida de contexto.
 */
export const CONSULTA_PANTALLA_TACTIL = '(pointer: coarse)';

/** true si el puntero principal es tactil. Se evalua en cada llamada (no se guarda en cache). */
export function esPantallaTactil(): boolean {
  try {
    return (
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(CONSULTA_PANTALLA_TACTIL).matches
    );
  } catch (e) {
    return false;
  }
}
